import React from 'react'
import EbookData from '../ebook.json'
import ServerInfo from '../server.json'
import '../App.css';
import {
    CardSection,
}from '../common'
import BottomBar from '../common/BottomBar'
import HeaderBar from '../common/HeaderBar'
//import {Route, Link} from 'react-router-dom';

import {connect } from 'react-redux'
import axios from 'axios'
import Login from './Login.js';


class EbookDetail extends React.Component {
    state = {
        currentEbook: '',
        isIframeOpen: false,
        ipAddress: ServerInfo.ipAddress,
        divWidth: null,
    }

    // constructor(props){
    //     super(props);
    //     this.state.showPopup = { showPopup: false };
    // }

    componentDidMount()
    {
        var ebookId = this.props.match.params.id
        // console.log(ebookId)
        this.findEbook(ebookId)
        this.setState({
            divWidth: this.container.offsetWidth
        });
    }
    render() {
        const { divWidth } = this.state;

        return(
            <div style={{minWidth:"320px"}} ref={el => (this.container = el)}>
                {divWidth && this.renderContent()}
            </div>
        )
    }

    renderContent()
    {
        const { divWidth } = this.state;

        if(this.state.currentEbook != '')
        {
            if(this.state.isIframeOpen === false )
            {
                return(
                    <div>
                        <HeaderBar history={this.props.history}></HeaderBar>
                        <div style={{padding: '80px 10px 100px 10px'}}>
                            {divWidth && this.renderPage()}
                        </div>
                        <BottomBar history={this.props.history}></BottomBar>
                    </div>
                );
            }
            
            else
            {
                return(
                    <div style={{ textAlign: 'center'}}>
                        <iframe className="IframeStyle" src={this.state.epubIframeLink}></iframe>
                        <button onClick={this.closeEpubIframe} style={styles.buttonStyle3}>CLOSE</button>
                    </div>
                )
            }
        }
        else
        {
            return null
        }
    }

    //in class
    gotoLibrary = () =>
    {
        this.props.history.push('/library')
    }

    findEbook (ebookId)
    {
        // axios({
        //     method: 'get',
        //     url: 'http://localhost:8080/content/getContentDetail/' + ebookId,
        //     responseType: 'stream'
        // })
        // .then(response => {
        //     // console.log(response.data)

        //     var tempData = response.data
        //     this.setState({
        //         currentEbook : tempData
        //     })
        //     console.log(this.state.currentEbook)
        // })
        // .catch(error => {
        //     console.log(error)
        // })
        for(var i=0; i<EbookData.length; i++)
        {
            if(EbookData[i].id === ebookId)
            {
                this.setState({ currentEbook : EbookData[i] })
                break
            }
        }
    }

    getEpubCover()
    {
        var epubFolder = this.state.currentEbook.category
        // change " " in epub folder to "_"
        if(epubFolder!=null){
            for(var i = 0; i < epubFolder.length; i++)
            {
                epubFolder = epubFolder.replace(" ", "_");
            }
        }
        return 'http://' + this.state.ipAddress + '/epub_content/' + epubFolder + '/' + this.state.currentEbook.id + '/cover.png'
        
        // return 'http://localhost:8080/file/content/image/' + this.state.currentEbook.content.image
    }

    handleEpub = (epubId, epubFolder) =>
    {
        this.setState({isIframeOpen: true})

        // change " " in epub folder to "_"
        var tempEpubFolder = epubFolder
        tempEpubFolder = this.stringManipulator(tempEpubFolder)
        
        this.setState({epubIframeLink: 'http://' + this.state.ipAddress + '/dev/index_RequireJS_no-optimize.html?epub=../epub_content/' + tempEpubFolder + '/' + epubId + '&goto=epubcfi(/6/2!/4/2/2)'})
        console.log(this.state.epubIframeLink)
        console.log(epubId)
    }
    gotoPage = (pageLink) =>
    {
        this.props.history.push(pageLink)
    }
    closeEpubIframe = () =>
    {
        this.setState({isIframeOpen: false})
    }
    stringManipulator (string)
    {
        for(var i = 0; i < string.length; i++)
        {
            string = string.replace(" ", "_");
        }
        return string
    }

    renderUser()
    {
        if(this.props.logged != 0)
        {
            return(
                <div>
                    <button style={styles.buttonStyle} onClick={()=> this.handleEpub(this.state.currentEbook.id, this.state.currentEbook.category)}>Read</button>
                </div>
            )
        }

        else
        {
            return(
                <div>
                    <button onClick={this.togglePopup.bind(this)} style={styles.buttonStyle}>Login to read</button>
                    {this.state.showPopup ?
                    <Login
                    closePopup={this.togglePopup.bind(this)}
                    />
                    : null
                    }
                </div>
            )
        }
    }

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    renderPage()
    {
        const { divWidth } = this.state;

        if (divWidth < 700)
        {
            return(
                <div style={{flex :1, minWidth: "320"}}>
                    <div style={{padding:5}}>
                        <CardSection >
                            <div className="row">
                                <div style={{width:"50%", textAlign:"center", float:"left"}}>
                                    <div style={{minWidth:"100px", float:"right", paddingRight:"10px"}}>
                                        <img
                                        style={{height: "100%"}}
                                        src={this.getEpubCover()}
                                        resizemode={"cover"}
                                        resizemethod={"scale"}
                                        alt=''
                                        />
                                    </div>
                                </div>
                                <div style={{width:"50%", float:"left"}}>
                                    <div style={{minWidth:"100px", paddingLeft:"10px"}}>
                                    <div style={styles.textTitle}>{this.state.currentEbook.title}</div>
                                        <p style={styles.contentFont1}>ID: {this.state.currentEbook.id}</p>
                                        <p style={styles.contentFont1}>PUBLISHER: {this.state.currentEbook.publisher}</p>
                                        <p style={styles.contentFont1}>CATEGORY: {this.state.currentEbook.category}</p>
                                        <CardSection style={{flexDirection: 'column'}}>
                                            <p style={styles.textDesc}>Description</p>
                                            <p style={styles.textSub}>{this.state.currentEbook.title}</p>
                                        </CardSection>
                                    </div>
                                </div>
                            </div>
    
                            <div style={{flex: 1, flexDirection: 'column', textAlign:'center'}}>
                                {this.renderUser()}
                                <button style={styles.buttonStyle2} onClick={this.gotoLibrary}>Back to Library</button>
                            </div>
                        </CardSection>
                    </div>
                </div>
            )
        }
        else
        {
            return(
                <div style={{flex :1, minWidth: "700px"}}>
                    <div style={{padding:5}}>
                        <CardSection >
                            <div className="row">
                                <div style={{width:"50%", minWidth:"340", textAlign:"center", float:"left"}}>
                                    <div style={{float:"right", paddingRight:"10px"}}>
                                        <img
                                        style={{width: 160}}
                                        src={this.getEpubCover()}
                                        resizemode={"cover"}
                                        resizemethod={"scale"}
                                        alt=''
                                        />
                                    </div>
                                </div>
                                <div style={{width:"50%", minWidth:"340", float:"left"}}>
                                    <div style={{paddingLeft:"10px"}}>
                                    <div style={styles.textTitle}>{this.state.currentEbook.title}</div>
                                        <p style={styles.contentFont1}>ID: {this.state.currentEbook.id}</p>
                                        <p style={styles.contentFont1}>PUBLISHER: {this.state.currentEbook.publisher}</p>
                                        <p style={styles.contentFont1}>CATEGORY: {this.state.currentEbook.category}</p>
                                        <CardSection style={{flexDirection: 'column'}}>
                                            <p style={styles.textDesc}>Description</p>
                                            <p style={styles.textSub}>{this.state.currentEbook.title}</p>
                                        </CardSection>
                                    </div>
                                </div>
                            </div>
    
                            <div style={{flex: 1, flexDirection: 'column', textAlign:'center'}}>
                                {this.renderUser()}
                                <button style={styles.buttonStyle2} onClick={this.gotoLibrary}>Back to Library</button>
                            </div>
                        </CardSection>
                    </div>
                </div>
            )
        }
    }
}

const styles = {
    textTitle:{
        fontSize : 20,
        fontWeight: "bold",
        paddingBottom:10,
        color: "black",
    },

    textDesc:{
        fontSize : 20,
        fontWeight: "bold",
        // paddingBottom:10,
        color: "black",
        textAlign: "left"
    },

    textSub:
    {
        fontSize: 15,
        // textAlign: 'justify',
    },
    pdf:
    {
        flex:1,
        //backgroundColor:"grey",
        alignItems: 'center',
    },

    loadingBar:{
        flex:1,
        width: "100%",
        justifyContent: 'center',
        position:"absolute" , 
    },

    sliderStyle :{
        flex:1,
        width: "100%",
        justifyContent: 'center',
        position:"absolute" , 
        zIndex : 1, 
        bottom:0,
        paddingBottom:10,
        paddingTop:10,
        backgroundColor:"#FFFFFF80",
        borderStartColor:"black"
    },
    textCon: {
        width: "100%",
        flexDirection: 'row',
        paddingLeft: 15,
        paddingRight: 15,
        justifyContent: 'space-between'
    },
    buttonStyle:
    {
        //flex: 1,
        backgroundColor: '#fff',
        borderRadius: 5,
        border: '1px solid #1e7b85',
        marginTop:12,        
        color: '#1e7b85',
        fontSize: 16,
        fontWeight: '600',
        padding: '10px 15px',
        width: '290px',
        cursor: 'pointer',
    },
    buttonStyle2:
    {
        //flex: 1,
        backgroundColor: '#fff',
        borderRadius: 5,
        border: '1px solid #f47141',
        marginTop:12,        
        color: '#f47141',
        fontSize: 16,
        fontWeight: '600',
        padding: '10px 15px',
        width: '290px',
        cursor: 'pointer'
    },
    buttonStyle3:
    {
        //flex: 1,
        backgroundColor: '#fff',
        borderRadius: 5,
        border: '1px solid #fc3232',
        marginTop:12,        
        color: '#fc3232',
        fontSize: 16,
        fontWeight: '700',
        padding: '10px 15px',
        width: '290px',
        cursor: 'pointer'
    },
    divider:
    {
        margin: '20px 10px',
        borderTop: '2px solid #e9edf8'
    },
    contentFont1:
    {
        color: '#57617a',
        fontSize: 14,
        fontWeight: 700,
        fontFamily: '"Source Sans Pro", sans-serif',
        margin: 0,
        marginBottom: 10,
        // width: '100px',
    },
    contentFont2:
    {
        color: '#1c263d',
        fontSize: 16,
        fontFamily: '"Source Sans Pro", sans-serif',
        margin: 0,
        marginBottom: 10,
        overflow: 'hidden',
    }
}

export default connect(state => state)(EbookDetail)